<template>

  <el-form label-position="left" label-width="auto" size="small">
    <el-collapse :accordion="true">
      <chart-title :element="element"></chart-title>
      <chart-sub-title :element="element"></chart-sub-title>
      <el-collapse-item name="字体" title="字体">
        <el-form-item label="最小字体">
          <el-input-number v-model="ele.option.series[0].sizeRange[0]"></el-input-number>
        </el-form-item>
        <el-form-item label="最大字体">
          <el-input-number v-model="ele.option.series[0].sizeRange[1]"></el-input-number>
        </el-form-item>
        <el-form-item label="字体间距">
          <el-input-number v-model="ele.option.series[0].gridSize"></el-input-number>
        </el-form-item>
        <el-form-item label="旋转范围(随机)">
          <el-slider v-model="ele.option.series[0].rotationRange" range :min="-90" :max="90"></el-slider>
        </el-form-item>


      </el-collapse-item>
    </el-collapse>
  </el-form>

</template>

<script>
import ChartTitle from "@/components/design-report/chart/chartStyle/chartTitle.vue";
import ChartSubTitle from "@/components/design-report/chart/chartStyle/chartSubTitle.vue";

export default {
  components: {   ChartSubTitle, ChartTitle},
  props: {
    element: {
      type: Object,
      default: () => {
      }
    },
    report: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      ele: null
    }
  },
  created() {
    this.ele = this.element;
  },
  methods: {
  }


}

</script>

<style scoped lang="scss">

</style>